import styled from 'styled-components'
import { colors, spacing } from '@chegg-ui/theme'
import { ShimmerBodyText, ShimmerTitleText } from '@chegg-ui/shimmer'
import { CARDS_CONTAINER_WIDTH } from '../Layout/styled'

export const ProofReaderCardsContainer = styled.div<{
  hasGreyBg: boolean
}>`
  width: ${CARDS_CONTAINER_WIDTH}px;
  padding: ${spacing.px16} 0;
  background: ${({ hasGreyBg }) => (hasGreyBg ? colors.grey050 : colors.white)};
  border-radius: 20px;
  margin-right: ${spacing.px48};
  border: 1px solid ${colors.grey100};
`
export const FeedbackCardsContainer = styled.div<{ isUndoRedoEnabled?: boolean }>`
  display: block;
  overflow: auto;
  position: relative;
  height: calc(
    100vh - 350px
  ); /* 290 is the height + top padding/margin of header, score, and tabs */
  /* 350 is the height + top padding/margin of header, score, tabs, AI-Powered message */
  overscroll-behavior: contain;
  padding: 0 ${spacing.px16};
`

export const ShimmerProgressBar = styled(ShimmerTitleText)`
  height: 6.25rem;
  width: calc(100% - ${spacing.px32});
  margin: 0 ${spacing.px16};
`

export const ShimmerActiveFeedbackCard = styled(ShimmerTitleText)`
  height: 9rem;
  width: 100%;
  margin: ${spacing.px8} 0;
`

export const ShimmerFeedbackCard = styled(ShimmerBodyText)`
  height: 4rem;
`

export const ShimmerSuggestionTabButton = styled(ShimmerTitleText)`
  width: 6.625rem;
  height: 2rem;
  border-radius: 15px;
`
export const ShimmerSuggestionTabsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${spacing.px8};
  margin: ${spacing.px16} 0;
  padding: 0 ${spacing.px16};
`
